import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import _ from 'underscore';
import { Page, Header, Alert } from 'components';
import { Popover, Typography, Grid } from '@mui/material';

import ReportRFCountersForm from './components/ReportRFCountersForm';

const useStyles = makeStyles(theme => ({
	root: {
		padding: theme.spacing(3)
	},
	container: {
		marginTop: theme.spacing(1)
	},
}));

const ReportRFCounters = () => {
	const classes = useStyles();
	const dispatch = useDispatch();

	return (
		<Page className={classes.root} title="Acceptance Tools">
			<Header module="Acceptance" view="RF Counters" />
			<br />
			<Grid container spacing={3}>
				<Grid item md={12} xs={12}>
					<ReportRFCountersForm />
				</Grid>
			</Grid>
		</Page>
	);
};

export default ReportRFCounters;
